import {
    Align,
    Box,
    BoxContent,
    DirectionEnum,
    FlexBox,
    GapSize,
    Text,
    TextLevels,
    TrilogyColor,
    TypographyAlign,
    TypographyBold,
} from '@bytel/trilogy-react';

import { BigIcon, BigIconVariant } from '@components/big';
import { InlinePrice } from '@components/inline-price';

interface FaiDiscountCalloutProps {
    discountAmount: number;
    discountDuration?: number;
}

export function FaiDiscountCallout({ discountAmount, discountDuration }: Readonly<FaiDiscountCalloutProps>) {
    return (
        <Box
            shadowless
            backgroundColor={TrilogyColor.ACCENT_FADE}
            highlighted={TrilogyColor.ACCENT}
            padding='md'
            radius='sm'
        >
            <BoxContent>
                <FlexBox align={Align.CENTER} gap={GapSize.TWO} direction={DirectionEnum.ROW}>
                    <BigIcon height={12} variant={BigIconVariant.ACCENT} />
                    <Text
                        level={TextLevels.TWO}
                        typo={[TypographyBold.TEXT_WEIGHT_SEMIBOLD, TypographyAlign.TEXT_LEFT]}
                    >
                        Avec un forfait, gardez la remise
                        <br />
                        de <InlinePrice amount={-discountAmount} level={TextLevels.TWO} />
                        {discountDuration && discountDuration > 0 && ` même après ${discountDuration} mois\u00A0!`}
                    </Text>
                </FlexBox>
            </BoxContent>
        </Box>
    );
}
